import { useState, useCallback, useRef, useEffect } from 'react';

export const useCallState = () => {
  const [activeCall, setActiveCall] = useState(null);
  const [incomingCall, setIncomingCall] = useState(null);
  const [callStatus, setCallStatus] = useState('idle'); // idle, ringing, active, held
  const [isMuted, setIsMuted] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
  const [callConnection, setCallConnection] = useState(null);
  const durationInterval = useRef(null);

  // Auto-increment call duration while active
  useEffect(() => {
    if (callStatus === 'active') {
      setCallDuration(0);
      durationInterval.current = setInterval(() => {
        setCallDuration((prev) => prev + 1);
      }, 1000);
    } else {
      if (durationInterval.current) {
        clearInterval(durationInterval.current);
        durationInterval.current = null;
      }
    }

    return () => {
      if (durationInterval.current) {
        clearInterval(durationInterval.current);
      }
    };
  }, [callStatus]);

  const startOutgoingCall = useCallback((connection) => {
    setActiveCall(connection);
    setCallStatus('active');
    setIsMuted(false);
  }, []);

  const receiveIncomingCall = useCallback((connection) => {
    setIncomingCall(connection);
    setCallStatus('ringing');
  }, []);

  const endCall = useCallback(() => {
    setActiveCall(null);
    setIncomingCall(null);
    setCallStatus('idle');
    setIsMuted(false);
    setCallConnection(null);
    setCallDuration(0);
  }, []);

  const holdCall = useCallback(() => {
    setCallStatus('held');
  }, []);

  const resumeCall = useCallback(() => {
    setCallStatus('active');
  }, []);

  return {
    activeCall,
    incomingCall,
    callStatus,
    isMuted,
    setIsMuted,
    callDuration,
    callConnection,
    setCallConnection,
    startOutgoingCall,
    receiveIncomingCall,
    endCall,
    holdCall,
    resumeCall,
  };
};
